import { render, staticRenderFns } from "./OvalShadow.vue?vue&type=template&id=bc7a1e9c&scoped=true"
import script from "./OvalShadow.vue?vue&type=script&lang=js"
export * from "./OvalShadow.vue?vue&type=script&lang=js"
import style0 from "./OvalShadow.vue?vue&type=style&index=0&id=bc7a1e9c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7a1e9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc7a1e9c')) {
      api.createRecord('bc7a1e9c', component.options)
    } else {
      api.reload('bc7a1e9c', component.options)
    }
    module.hot.accept("./OvalShadow.vue?vue&type=template&id=bc7a1e9c&scoped=true", function () {
      api.rerender('bc7a1e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/OvalShadow.vue"
export default component.exports